import { AutorisationAggregate } from '../../../../../aggregats/autorisation/autorisation.aggregate';
import { AutorisationsAggregate } from '../../../../../aggregats/autorisation/autorisations.aggregate';
import { SousMenuItemAggregate } from '../../../../../aggregats/menu/sous-menu-item.aggregate';
import { FonctionLogicielle } from '../../../../fonctions-logicielle-constantes';
import { EparcoursPath } from '../../eparcours-path';

export const suiviDocumentsSousMenuItem = new SousMenuItemAggregate(
  'Suivi des documents',
  `/${EparcoursPath.root.SUIVI_DOCUMENTS}`,
  new AutorisationsAggregate([new AutorisationAggregate(FonctionLogicielle.Publipostage)]),
);

export const modelesSousMenuItem = new SousMenuItemAggregate(
  'Modèles documents',
  `/${EparcoursPath.root.PUBLIPOSTAGE_MODELES}`,
  new AutorisationsAggregate([new AutorisationAggregate(FonctionLogicielle.ConceptionModeles)]),
);

export const evaluationsModelesSousMenuItem = new SousMenuItemAggregate(
  'Modèles évaluations',
  `/${EparcoursPath.root.EVALUATIONS}`,
  new AutorisationsAggregate([new AutorisationAggregate(FonctionLogicielle.Evaluations)], null, true),
);

export const suiviAutomatisationsSousMenuItem = new SousMenuItemAggregate(
  'Suivi des automatisations',
  `/${EparcoursPath.root.SUIVI_AUTOMATISATIONS}`,
  new AutorisationsAggregate([new AutorisationAggregate(FonctionLogicielle.ParametresAutomatisations)]),
);


